import { compose } from 'redux'
import { connect } from 'react-redux'
import { mapProps } from 'recompose'
import * as actions from './actions'
import { getMyLocationIds } from './selectors'

const withGroupedActions = mapProps(({
  getMyLocations,
  setMyLocation,
  isLoading,
  error,
  ...props
}) => ({
  ...props,
  myLocationHandlers: {
    getMyLocations,
    setMyLocation,
    isLoading,
    error
  }
}))

export default compose(
  connect(getMyLocationIds, actions),
  withGroupedActions
)
